import React from "react";
import ErrorMsg from "../../components/ErrorMsg";
export default function () {
  return <ErrorMsg />;
}
